<template>
  <div id="container" v-if="fetch_data">

    <section id="mypage">
      <div class="wrap">

        <div class="cts_box">
          <h3 class="child_ttl">講義動画の購入を受け付けました</h3>
          <p class="lead_txt alnC sp_alnL">
            講義動画の購入が完了しました。
          </p>

          <div class="button_wrap">
            <router-link :to="{name: 'UsersCustomerTop'}" class="submit basic">複眼経済塾トップ</router-link>
          </div>
          <div class="button_wrap">
            <router-link :to="{name: 'UsersCustomerAccount'}" class="submit light skeleton">マイページ</router-link>
          </div>
        </div>

      </div>
    </section>

    <div id="b_listBox">
      <ul id="b_list">
        <li>
          <router-link to="/">トップページ</router-link>
        </li>
        <li>
          <router-link :to="{name: 'UsersCustomerAccount'}">マイページ</router-link>
        </li>
        <li>講義動画の購入が完了しました</li>
      </ul>
    </div>

    <PaygentStatusModal v-if="paygent_status === 'status_waiting' || paygent_status === 'status_authory_ok'" />
    <PaygentStatusFailedModal v-if="paygent_status === 'status_failed'" />
    <PaygentStatusCancelModal v-if="paygent_status === 'status_cancel'" />
  </div>
</template>

<script>

import Libraries from '@/components/Libraries'
import PaygentStatusFailedModal from "@/components/paygentStatusFailedModal.vue";
import PaygentStatusModal from "@/components/paygentStatusModal.vue";
import PaygentStatusCancelModal from '@/components/paygentStatusCancelModal.vue'

export default {
  components: {PaygentStatusModal, PaygentStatusFailedModal, PaygentStatusCancelModal},
  mixins: [Libraries],
  data() {
    return {
      modal_open: false,  // モーダル非表示 ：this.$route.query.any_registered_meetings === 'true',
      paygent_status: 'status_paid',
      fetch_data: null
    }
  },
  mounted() {
    // form token
    this.removeFormToken('PostSales')
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}sns/sns_post_sale.json`, {
            params: {
              id: this.$route.params.id,
            }
          })
          .then(response => {
            this.fetch_data = response.data
            // sync paygent status
            this.startPaygentStatusPolling((status) => {
              this.paygent_status = status
            });
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    }
  }
}
</script>
